import { FormControlProps, FormLabelProps } from '@chakra-ui/react';
import { ChakraComponents as CC } from '@Modules/core/lib/chakra';

export type TCustomFormControlProps = {
  children: React.ReactNode,
  label?: string,
  isInvalid?: boolean,
  isLoading?: boolean,
  hasLoader?: boolean,
  // errors?: any,
  labelStyle?: FormLabelProps,
  helperText?: string,
  isCheckbox?: boolean,
} & FormControlProps;

export default function CustomFormControl({
  children,
  label,
  isInvalid,
  isLoading,
  hasLoader = true,
  isCheckbox,
  // errors,
  labelStyle,
  ...rest
}: TCustomFormControlProps) {
  // const isInvalid = errors ? true : false;

  return (
    <CC.FormControl mb={{ base: '2' }} {...rest} isInvalid={isInvalid}>
      { (
        <CC.Skeleton isLoaded={hasLoader && !isLoading} w={'95%'}>
          {label ?
          <CC.FormLabel {...labelStyle}>{label}</CC.FormLabel>
          : !isCheckbox ?
          <CC.FormLabel {...labelStyle} visibility={'hidden'} userSelect={'none'}>{'Default label'}</CC.FormLabel> : null
          }
        </CC.Skeleton>
      )}
      
      <CC.Skeleton isLoaded={hasLoader && !isLoading}>{children}</CC.Skeleton>
    </CC.FormControl>
  );
}
